import { render, staticRenderFns } from "./Flotillas.vue?vue&type=template&id=6fbdf384&"
import script from "./Flotillas.vue?vue&type=script&lang=js&"
export * from "./Flotillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports